import React from 'react';
import './style.scss';
import { Link } from 'react-router-dom';
import { trackGAEvent } from '../../../shared/helpers';

// import imgPromoEn from '../i/en/kids-pack.jpg';
// import imgPromoFr from '../i/fr/kids-pack.jpg';
// import imgPromoEn from '../i/en/56-burger-2023.jpg';
// import imgPromoFr from '../i/fr/56-burger-2023.jpg';
// import imgPromoEn from '../i/en/coffee-crisp-turnover.jpg';
// import imgPromoFr from '../i/fr/coffee-crisp-turnover.jpg';
// import imgPromoEn from '../i/en/grass-fed-beef.jpg';
// import imgPromoFr from '../i/fr/grass-fed-beef.jpg';
// import imgPromoEn from '../i/en/nuggets-en.jpg';
// import imgPromoFr from '../i/fr/nuggets-fr.jpg';
// import imgPromoEn from '../i/en/good-coffee.jpg';
// import imgPromoFr from '../i/fr/good-coffee.jpg';
// import imgPromoEn from '../i/en/fly-the-coop-contest-en.jpg';
// import imgPromoFr from '../i/fr/fly-the-coop-contest-fr.jpg';
// import imgPromoEn from '../i/en/whistledog-bj-en.jpg';
// import imgPromoFr from '../i/fr/whistledog-bj-fr.jpg';
//import imgPromoEn from '../i/en/whistledog-promo-en.jpg';
//import imgPromoFr from '../i/fr/whistledog-promo-fr.jpg';
// import imgPromoEn from '../i/en/frozen-root-beer-2023.jpg';
// import imgPromoFr from '../i/fr/frozen-root-beer-2023.jpg';
// import imgPromoEn from '../i/en/psl-en.jpg';
// import imgPromoFr from '../i/fr/psl-fr.jpg';
// import imgPromoEn from '../i/en/chicken-cheddar-en.jpg';
// import imgPromoFr from '../i/fr/chicken-cheddar-fr.jpg';
// import imgPromoEn from '../i/en/onecup-promo-en.jpg';
// import imgPromoFr from '../i/fr/onecup-promo-fr.jpg';
// import imgPromoEn from '../i/en/chicken-crunchers-2024.jpg';
// import imgPromoFr from '../i/fr/chicken-crunchers-2024.jpg';
// import imgPromoEn from '../i/en/latte-turnover-en.jpg';
// import imgPromoFr from '../i/fr/latte-turnover-fr.jpg';
//import imgPromoEn from '../i/en/stackers-2024-en.jpg';
//import imgPromoFr from '../i/fr/stackers-2024-fr.jpg';
//import imgPromoEn from '../i/en/blue-jays-win-en.jpg';
//import imgPromoFr from '../i/fr/blue-jays-win-fr.jpg';
//import imgPromoEn from '../i/en/pup-patty-en.jpg';
//import imgPromoFr from '../i/fr/pup-patty-fr.jpg';
//import imgPromoEn from '../i/en/mango-passionfruit-en.jpg';
//import imgPromoFr from '../i/fr/mango-passionfruit-fr.jpg';
//import imgPromoEn from '../i/en/blue-jays-free-fries-en.jpg';
//import imgPromoFr from '../i/fr/blue-jays-free-fries-fr.jpg';

//import imgPromoEn from '../i/en/25-gift-card-en.jpg';
//import imgPromoFr from '../i/fr/25-gift-card-fr.jpg';
//import imgPromoEn from '../i/en/buddy-bundle-en.jpg';
//import imgPromoFr from '../i/fr/buddy-bundle-fr.jpg';
//import imgPromoEn from '../i/en/pret-1-coffee-2-latte-en.jpg';
//import imgPromoFr from '../i/fr/pret-1-coffee-2-latte-fr.jpg';
//import imgPromoEn from '../i/en/OurCompany-EN.jpg';
//import imgPromoFr from '../i/fr/OurCompany-FR.jpg';
//import imgPromoEn from '../i/en/stackers-en.jpg';
//import imgPromoFr from '../i/fr/stackers-fr.jpg';
import imgPromoEn from '../i/en/OurCompany3-EN.png';
import imgPromoFr from '../i/fr/OurCompany3-FR.png';
//import imgPromoEn from '../i/en/teen_awareness2-en.png';
//import imgPromoFr from '../i/fr/teen_awareness2-fr.png';

const SubPromo1 = (props) => {
    //let promo1URL = '/' + props.lang + '/our-menu/featured';
    //let promo1URL = '/' + props.lang + '/our-menu/chicken/chicken-nuggets';
    //let promo1URL = '/' + props.lang + '/our-values/our-food/coffee';
    //let promo1URL = '/' + props.lang + '/our-values/our-food/beef';
   //let promo1URL = '/' + props.lang + '/our-values/our-food/burgers';
   //let promo1URL = '/' + props.lang + '/our-menu/burgers';
    // let promo1URL = '/' + props.lang + '/our-menu/kidspack';
    //let promo1URL = '/' + props.lang + '/our-menu/burgers/56-buddy-burger';
    //let promo1URL = '/' + props.lang + '/our-menu/brewbar/frozen-aw-root-beer';
    //let promo1URL = '/' + props.lang + '/our-menu/brewbar';
    // let promo1URL = '/' + props.lang + '/our-menu/breakfast/chicken-cheddar';
    //let promo1URL = '/' + props.lang + '/onecup';
    //let promo1URL = '/' + props.lang + '/our-menu/chicken';
    //let promo1URL = 'https://www.mlb.com/bluejays';
    //let promo1URL = '/' + props.lang + '/our-menu/chicken/whistle-dog';
    //let promo1URL = '/' + props.lang + '/our-menu/burgers/pup-patty';
    //let promo1URL = '/' + props.lang + '/order';
    let promo1URL = '/' + props.lang + '/company';
    //let promo1URL = '/' + props.lang + '/our-menu/burgers/teen-burger';
    

    // need custom urls?
    // let promo2URL = (props.lang === 'en') ? 'https://www.mlb.com/bluejays' : 'https://web.aw.ca/fr/our-menu/burgers/teen-burger';

    let imgPromo1 = (props.lang === 'en') ? imgPromoEn : imgPromoFr;
   // let imgDesc = (props.lang === 'en') ? "Chicken nuggets" : "croquettes de poulet";
   // let imgDesc = (props.lang === 'en') ? "Just a good cup of coffee." : "un vrai bon café tout simplement";
   // let imgDesc = (props.lang === 'en') ? "Grass-fed grass-finished beef." : "bœuf nourri à l'herbe";
   //let imgDesc  = (props.lang === 'en') ? "The '56 Burger is back" : "La famille royale est de retour";
   //let imgDesc = (props.lang === 'en') ? "Try the new Frozen A&W Root Beer" : "Goûtez à la nouvelle Root Beer A&W™ frappée";
  //  let imgDesc = (props.lang ==='en') ? "Fall's favourite flavour is back." : "automne en vue, citrouille au menu!";
   //let imgDesc = (props.lang ==='en') ? "One cup. Zero waste. The exchangeable A&W One Cup™." : "Un verre. Zéro déchet. Le Verre vert™ A&W.";
   //let imgDesc  = (props.lang === 'en') ? "Kids Pack" : "le nouveau régal pour enfants";
   // let imgDesc = (props.lang === 'en') ? "Fly the coop contest" : "concours tu poulet partir loin";
    //let imgDesc = (props.lang === 'en') ? "The Whistle Dog is back" : "Le Whistle Dog est de retour.";
    // let imgDesc1 = (props.lang === 'en') ? "The official burger of the Blue Jays" : "Le burger officiel des Toronto Blue Jays";
    //let imgDesc = (props.lang === 'en') ? "Crunch Crunch Crunch. Try our new Chicken Crunchers" : "MÉGA MÉGA MÉGACROUSTILLANT. Goûtez à nos nouveaux sandwichs au poulet MÉGAcroustillant.";
    //let imgDesc = (props.lang === 'en') ? "Small latte & turnover" : "Petit latte et chausson";
    //let imgDesc = (props.lang === 'en') ? "Blue Jays Win, You Win. Check the A&W app for a free offer the day after every win." : "Quand les Toronto Blue Jays gagnent, vous gagnez aussi.";
    //let imgDesc = (props.lang === 'en') ? "Mango Passionfruit. Try our new delicious tropical trio, for a limited time only." : "Mangue et fruit de la passion. Trois nouvelles boissons tropicales qui vont soulever les passions. Pour un temps limité.";
    //let imgDesc = (props.lang === 'en') ? "Ruffles* Crunch Buddy Burger®" : "Buddy Burger™ croustillant avec Ruffles*";
    //let imgDesc = (props.lang === 'en') ? "Buy a $25 gift card and get a free Teen Burger® coupon to enjoy later" : "Achetez une carte-cadeau de 25 $ et obtenez un coupon à échanger plus tard contre un Teen Burger™";
    //let imgDesc = (props.lang === 'en') ? "Teen Burger®" : "Teen Burger™";
    //let imgDesc = (props.lang === 'en') ? "A Buddy® for our Buddies" : "Oui, c'est 6 $ pour ça";
    //let imgDesc = (props.lang === 'en') ? "Pret $1 Coffee $2 Latte" : "Petit Café 1 $ Petite Latte 2 $";
    let imgDesc = (props.lang === 'en') ? "Canadian Owned & Operated" : "Enterprise Fièrement Canadienne";
    //let imgDesc = (props.lang === 'en') ? "Stackers" : "L'Étagé";
    
       //<a onClick={() => trackGAEvent("Home Page", "Left Block", "Variable 1")} href={promo2URL} className="sub-promo-2" title={imgDesc1}>
        //    <img src={imgPromo1} alt={imgDesc1} width="900" height="491" />
        //</a>

    return(

        <Link onClick={() => trackGAEvent("Home Page", "Left Block", "Variable 1")} to={promo1URL} className="sub-promo-1" title={imgDesc}>
            <img src={imgPromo1} alt={imgDesc} width="900" height="491" />
        </Link>

    )
}
export default SubPromo1;
